/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */

import { useCallback } from 'react';
import { InputNumber, InputNumberValue, Textarea } from 'tdesign-react';

import { IScoreRule } from '@/interface';

import styles from './styles/index.module.less';

const Item = (props: {
  value: IScoreRule;
  disabled?: boolean;
  onChange: (value: IScoreRule) => void
}) => {
  const { value, disabled = false, onChange } = props;

  const handleChange1 = useCallback((val: InputNumberValue) => {
    onChange({ ...value, rangeMin: val as number });
  }, [onChange, value]);

  const handleChange2 = useCallback((val: InputNumberValue) => {
    onChange({ ...value, rangeMax: val as number });
  }, [onChange, value]);

  const handleChange3 = useCallback((val: string) => {
    onChange({ ...value, rule: val });
  }, [onChange, value]);

  return <div className={styles.root}>
    <div className={styles.ranges}>
      <div className={styles.range}>
        <div className={styles.label}>最小值：</div>
        <InputNumber min={0} max={100} disabled={disabled} value={value.rangeMin} onChange={handleChange1} />
      </div>
      <div className={styles.range}>
        <div className={styles.label}>最大值：</div>
        <InputNumber min={0} max={100} disabled={disabled} value={value.rangeMax} onChange={handleChange2} />
      </div>
    </div>
    <Textarea
      disabled={disabled}
      autosize={{ minRows: 5, maxRows: 5 }}
      value={value.rule}
      className={styles.content}
      onChange={handleChange3}
    />
  </div>;
};

export default Item;
